import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_STATUSES'),
  ...asyncTypes('CREATE_STATUSES')
};

export default TYPES;
